import { showConfirmDialog } from '~/composables/useConfirmDialog';
import { appT } from '~/composables/useAppI18n';

/** TinyMCE 활동 본문에 실제 내용이 있는지 판별 */
export const hasActivityEditorContent = (html: string | undefined | null): boolean => {
  if (!html) return false;
  const str = String(html);
  if (/<(img|iframe|video|audio|embed|object|svg|table|hr)\b/i.test(str)) return true;
  const text = str.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
  return text.length > 0;
};

/** replaceExisting: true=초기화 후 적용, false=기존 내용 뒤에 추가 */
export const mergeActivityTemplateContent = (
  currentContent: string,
  templateContent: string,
  replaceExisting: boolean,
): string => {
  if (replaceExisting) return templateContent;
  return `${currentContent}${templateContent}`;
};

/** 기존 내용이 있으면 확인 후 적용 (예=초기화, 아니오=추가) */
export const confirmActivityTemplateApply = (options: {
  currentContent: string;
  onApply: (replaceExisting: boolean) => void;
}) => {
  const { currentContent, onApply } = options;

  if (!hasActivityEditorContent(currentContent)) {
    onApply(true);
    return;
  }

  showConfirmDialog(
    appT('common.confirm'),
    appT('task.home.taskModal.template.confirmExistingContent'),
    () => onApply(true),
    () => onApply(false),
    'warning',
    '',
    {
      mouseOnly: true,
      confirmButtonText: appT('common.yes'),
      cancelButtonText: appT('common.no'),
      confirmButtonFirst: true,
    },
  );
};
